import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Button, Icon, StandardLayout } from '@factorialco/factorial-one-react'
import { AlertCircleLine } from '@factorialco/factorial-one-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const MeetingErrorLayout = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <StandardLayout variant="narrow">
      <Box
        gap="s12"
        alignItems="center"
        justifyContent="center"
        position="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Icon icon={AlertCircleLine} size="lg" color="red" />
        <Text.Header3>{i18n.t('meetings.meeting.not_found_description')}</Text.Header3>
        <Button
          // TODO: change this with a hook that retrives the meeting type
          onClick={() => navigate(navigation.engagement.one_on_ones.fullPath())}
          variant="outline"
          label={i18n.t('meetings.meeting.not_found_button')}
        />
      </Box>
    </StandardLayout>
  )
}
